import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { DocumentFileTemplateFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template/document-file-template-find-many-query.dto';
import { Observable } from 'rxjs';
import type { DocumentFileTemplatePageInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template/document-file-template-page.dto';
import type { DocumentFileTemplateFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template/document-file-template-find.dto';
import type { DocumentFileTemplateLogPageInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-log/document-file-template-log-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';

@Injectable({
  providedIn: 'root'
})
export class BasisDocumentFileTemplateService extends BaseService {
  protected baseUrl = '/basis/catalog/document-file-template';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(
    queryParams?: DocumentFileTemplateFindManyQueryInterface
  ): Observable<DocumentFileTemplatePageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<DocumentFileTemplatePageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findWithPagination(
    queryParams: DocumentFileTemplateFindManyQueryInterface
  ): Observable<DocumentFileTemplatePageInterface> {
    return this.findPage(queryParams);
  }

  public restore(id: number): Observable<DocumentFileTemplateFindInterface> {
    return this.http.post<DocumentFileTemplateFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getLog(id: number, queryParams: PaginationQueryInterface): Observable<DocumentFileTemplateLogPageInterface> {
    return this.http.get<DocumentFileTemplateLogPageInterface>(`${this.baseUrl}/${id}/log`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
